import { UserDetailAssignmentProposalsComponent } from './user-detail-assignment-proposals/user-detail-assignment-proposals.component';
import { UserDetailProfileComponent } from './user-detail-profile/user-detail-profile.component';
import { CartsComponent } from './carts/carts.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { ItinerarySnapshotsComponent } from './itinerary-snapshots/itinerary-snapshots.component';
import { ItinerarySettingsComponent } from './itinerary-settings/itinerary-settings.component';
import { LinkRouterComponent } from './link-router/link-router.component';
import { CustomerGuard } from './customer.guard';
import { UserDetailComponent } from './user-detail/user-detail.component';
import { UserGuard } from './user.guard';
import { HomeComponent } from './home/home.component';
import { AdminGuard } from './admin.guard';
import { CouponsComponent } from './coupons/coupons.component';
import { ItineraryPreviewComponent } from './itinerary-preview/itinerary-preview.component';
import { CartResolverService } from './cart-resolver.service';
import { ItineraryCustomerRequestsTypeformComponent } from './itinerary-customer-requests-typeform/itinerary-customer-requests-typeform.component';
import { ItineraryCustomerRequestsCartComponent } from './itinerary-customer-requests-cart/itinerary-customer-requests-cart.component';
import { ItineraryDayPoisComponent } from './itinerary-day-pois/itinerary-day-pois.component';
import { ItineraryDayInfoComponent } from './itinerary-day-info/itinerary-day-info.component';
import { ItineraryReservationsBusesComponent } from './itinerary-reservations-buses/itinerary-reservations-buses.component';
import { ItineraryResolverService } from "./itinerary-resolver.service";
import { ItineraryReservationsFerriesComponent } from "./itinerary-reservations-ferries/itinerary-reservations-ferries.component";
import { ItineraryReservationsTrainsComponent } from "./itinerary-reservations-trains/itinerary-reservations-trains.component";
import { ItineraryReservationsCarsComponent } from "./itinerary-reservations-cars/itinerary-reservations-cars.component";
import { ItineraryReservationsAccomodationsComponent } from "./itinerary-reservations-accomodations/itinerary-reservations-accomodations.component";
import { ItineraryReservationsFlightsComponent } from "./itinerary-reservations-flights/itinerary-reservations-flights.component";
import { ItineraryCustomerRequestsComponent } from "./itinerary-customer-requests/itinerary-customer-requests.component";
import { ItineraryExpensesComponent } from "./itinerary-expenses/itinerary-expenses.component";
import { ItineraryDayComponent } from "./itinerary-day/itinerary-day.component";
import { ItineraryReservationsComponent } from "./itinerary-reservations/itinerary-reservations.component";
import { ItineraryInfoComponent } from "./itinerary-info/itinerary-info.component";
import { ItineraryComponent } from "./itinerary/itinerary.component";
import { ItineraryListComponent } from "./itinerary-list/itinerary-list.component";
import { TravelAdvisorGuard } from "./travel-advisor.guard";
import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { LoginComponent } from "./login/login.component";
import { LogoutComponent } from "./logout/logout.component";
import { ItineraryDayActivitiesComponent } from './itinerary-day-activities/itinerary-day-activities.component';
import { UserListComponent } from './user-list/user-list.component';
import { CustomerHomeComponent } from './customer-home/customer-home.component';
import { CustomerItineraryComponent } from './customer-itinerary/customer-itinerary.component';
import { ItineraryReviewComponent } from './itinerary-review/itinerary-review.component';
import { ItineraryCustomerRequestsInfoComponent } from './itinerary-customer-requests-info/itinerary-customer-requests-info.component';
import { DashboardNavigatorComponent } from './dashboard-navigator/dashboard-navigator.component';
import { UserDetailDestinationsComponent } from './user-detail-destinations/user-detail-destinations.component';

const routes: Routes = [
  {
    path: "",
    component: HomeComponent,
    canActivate: [UserGuard]
  },
  {
    path: "link",
    component: LinkRouterComponent,
    canActivate: [UserGuard]
  },
  {
    path: "login",
    component: LoginComponent
  },
  {
    path: "logout",
    component: LogoutComponent
  },
  {
    path: "coupons",
    component: CouponsComponent,
    canActivate: [AdminGuard]
  },
  {
    path: "carts",
    component: CartsComponent,
    canActivate: [AdminGuard]
  },
  {
    path: "dashboard",
    component: DashboardNavigatorComponent,
    canActivate: [AdminGuard],
    children: [
      { path: "", redirectTo: "pzHr", pathMatch: "full" },
      { path: ":page", component: DashboardComponent, canActivate: [AdminGuard], }
    ]
  },
  {
    path: "users",
    component: UserListComponent,
    canActivate: [AdminGuard]
  },
  {
    path: "user/me",
    component: UserDetailComponent,
    canActivate: [TravelAdvisorGuard],
    children: [
      { path: "", redirectTo: "profile", pathMatch: "full" },
      { path: "profile", component: UserDetailProfileComponent },
      { path: "assignment-proposals", component: UserDetailAssignmentProposalsComponent },
      { path: "destinations", component: UserDetailDestinationsComponent },
    ]
  },
  {
    path: "user/:userId",
    component: UserDetailComponent,
    canActivate: [AdminGuard],
    children: [
      { path: "", redirectTo: "profile", pathMatch: "full" },
      { path: "profile", component: UserDetailProfileComponent },
      { path: "assignment-proposals", component: UserDetailAssignmentProposalsComponent },
      { path: "destinations", component: UserDetailDestinationsComponent },
    ]
  },
  {
    path: "itineraries",
    component: ItineraryListComponent,
    canActivate: [TravelAdvisorGuard]
  },
  {
    path: "itineraries/:itineraryId",
    pathMatch: "prefix",
    component: ItineraryComponent,
    canActivate: [TravelAdvisorGuard],
    resolve: { itinerary: ItineraryResolverService },
    children: [
      { path: "", redirectTo: "info", pathMatch: "full" },
      { path: "settings", component: ItinerarySettingsComponent, canActivate: [AdminGuard] },
      { path: "info", component: ItineraryInfoComponent },
      {
        path: "customer-requests",
        component: ItineraryCustomerRequestsComponent,
        resolve: { cart: CartResolverService },
        children: [
          { path: "", redirectTo: "info", pathMatch: "full" },
          { path: "info", component: ItineraryCustomerRequestsInfoComponent },
          { path: "cart", component: ItineraryCustomerRequestsCartComponent, canActivate: [AdminGuard] },
          {
            path: "typeform/:typeformNumber",
            component: ItineraryCustomerRequestsTypeformComponent
          },
        ]
      },
      {
        path: "reservations",
        component: ItineraryReservationsComponent,
        children: [
          { path: "", redirectTo: "flights", pathMatch: "full" },
          { path: "flights", component: ItineraryReservationsFlightsComponent },
          {
            path: "accomodations",
            component: ItineraryReservationsAccomodationsComponent
          },
          {
            path: "cars",
            component: ItineraryReservationsCarsComponent
          },
          {
            path: "trains",
            component: ItineraryReservationsTrainsComponent
          },
          {
            path: "ferries",
            component: ItineraryReservationsFerriesComponent
          },
          {
            path: "buses",
            component: ItineraryReservationsBusesComponent
          }
        ]
      },
      {
        path: "day/:dayId", component: ItineraryDayComponent,
        children: [
          { path: "", redirectTo: "info", pathMatch: "full" },
          { path: "info", component: ItineraryDayInfoComponent },
          {
            path: "activities",
            component: ItineraryDayActivitiesComponent
          },
          {
            path: "pois",
            component: ItineraryDayPoisComponent
          }
        ]
      },
      { path: "expenses", component: ItineraryExpensesComponent },
      { path: "preview", component: ItineraryPreviewComponent },
      { path: "review", component: ItineraryReviewComponent },
      { path: "snapshots", component: ItinerarySnapshotsComponent, canActivate: [AdminGuard] },
    ]
  },
  { path: "customer", redirectTo: "customer/itineraries", },
  {
    path: "customer/itineraries",
    component: CustomerHomeComponent,
    canActivate: [CustomerGuard],
  },
  { path: "customer/itineraries/:itineraryId", component: CustomerItineraryComponent, canActivate: [CustomerGuard], resolve: { itinerary: ItineraryResolverService }, },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
